<template>
    <div>
        <div class="h2 mb-2">
            {{ title }}
        </div>
        <div class="row">
            <template v-for="(zoneOffersItem, index) in zoneOffers.zoneOffersItem">
                <div :key="index" class="col-12 col-md-6" :class="(index > 0) ? 'mt-1 mt-md-0' : ''">
                    <ob1-cards class="d-flex flex-column h-100 border-0" :is-multiple="true" :with-composite-link="true">
                        <img :src="zoneOffersItem.image.src" class="w-100" :alt="zoneOffersItem.image.alt">
                        <div class="px-1 px-md-2 d-flex flex-column flex-grow-1 bg-white">
                            <h3 class="text-primary mt-1 pb-0 mb-0">
                                {{ zoneOffersItem.title }}
                            </h3>
                            <div class="lead mb-1">
                                {{ zoneOffersItem.text }}
                            </div>
                            <ob1-boutons
                                class="mb-2 mt-auto align-self-center align-self-md-start"
                                :is-secondary="true"
                                :is-button="false"
                                :label="zoneOffersItem.labelButton"
                                :href="zoneOffersItem.urlButton"
                                :data-oevent-category="zoneOffersItem.tms.tagZone"
                                :data-oevent-action="zoneOffersItem.tms.tagName"
                                :data-oevent-label="zoneOffersItem.urlButton"
                            />
                        </div>
                    </ob1-cards>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        zoneOffers: {
            type: Object,
            required: true
        },
    },
    methods: {

    },
}
</script>

<style scoped lang="scss">

</style>
